export default {
  namespaced: true,
  state: {
    formData: {
      projection: "Web Mercator",
      scale: "4",
      switchNorth: false,
      switchMiniMap: true,
      switchGrid: false,
      title: "",
      description: "",
      format: "PNG",
    },
    mapData: {
      mainMap: null,
      graticule: null,
      initCenter: [39.9042, 116.4074],
      bbox: {
        west: null,
        south: null,
        east: null,
        north: null
      }
    },
  },
  mutations: {
    updateFormData(state, payload) {
      for (const key in payload) {
        state.formData[key] = payload[key];
      }
    },
    updateMapData(state, payload) {
      state.mapData = { ...state.mapData, ...payload };
    },
  },
  actions: {
    submitFormData({ state }) {
      console.log("Form submitted:", state.formData);
    },
  },
};
